const MaskHelper = {
  currency: (value: string | number, prefix = "") =>
    `${prefix}${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`,
};

export default MaskHelper;
